import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreCommonModule } from '@core/common.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { RoleManagmentUpdateComponent } from './role-managment-update/role-managment-update.component';
import { NgbDatepickerModule, NgbModalModule, NgbModule, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { ProductCreateSerialnoComponent } from './product-create-serialno/product-create-serialno.component';
import { ProductMovementCreateComponent } from './product-movement-create/product-movement-create.component';
import { SubProductCreateComponent } from './sub-product-create/sub-product-create.component';
import { TransactionCreateDilaogComponent } from './transaction-create-dilaog/transaction-create-dilaog.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { Ng2FlatpickrModule } from 'ng2-flatpickr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TransactionUpdateDialogComponent } from './transaction-update-product-dialog/transaction-update-dialog.component';
import { TransactionUpdateComponent } from './transaction-update-dialog/transaction-update.component';
import { TransactionPrivateCodeConfirmedDialogComponent } from './transaction-private-code-confirmed-dialog/transaction-private-code-confirmed-dialog.component';
import { CreateVaultDialogComponent } from './create-vault-dialog/create-vault-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CreateVaultMovementComponent } from './create-vault-movement/create-vault-movement.component';
import { FileUploadDialogComponent } from './file-upload-dialog/file-upload-dialog.component';
import { CreatePersonComponent } from './create-person/create-person.component';
import { NgxMaskModule } from 'ngx-mask';
import { SendpdfDialogComponent } from './sendpdf-dialog/sendpdf-dialog.component';
import { CreateVaultCompanyMovementComponent } from './create-vault-company-movement/create-vault-company-movement.component';
import { CreateActionComponent } from './create-action/create-action.component';
import { QuillModule } from 'ngx-quill';
import { BlockUIModule } from 'ng-block-ui';
import { SendPrintTransactionComponent } from './send-print-transaction/send-print-transaction.component';
import { CreateCompanyComponent } from './create-company/create-company.component';
import { CreateProductComponent } from './create-product/create-product.component';
import { CreateWorkerDialogComponent } from './create-worker-dialog/create-worker-dialog.component';
import { PersonLeaveComponent } from './person-leave/person-leave.component';
import { PayrollComponent } from './payroll/payroll.component';
import { PersonPointDialogComponent } from './person-point-dialog/person-point-dialog.component';
import { CreateBrandModelComponent } from './create-brand-model/create-brand-model.component';
import { CreateDeviceDialogComponent } from './create-device-dialog/create-device-dialog.component';
import { DeviceDeliveryDialogComponent } from './device-delivery-dialog/device-delivery-dialog.component';
import { UpdateDeviceDialogComponent } from './update-device-dialog/update-device-dialog.component';
import { ReferenceTransactionsComponent } from './reference-transactions/reference-transactions.component';
import { ProcedureDialogComponent } from './procedure-dialog/procedure-dialog.component';
import { DeviceClassDialogComponent } from './device-class-dialog/device-class-dialog.component';
import { CreateDeliveryDeviceComponent } from './create-delivery-device/create-delivery-device.component';
import { DeliveryUpdateDialogComponent } from './delivery-update-dialog/delivery-update-dialog.component';
import { DeliveryDeviceUpdateDialogComponent } from './delivery-device-update-dialog/delivery-device-update-dialog.component';
import { DialogReferenceDeviceMovementComponent } from './dialog-reference-device-movement/dialog-reference-device-movement.component';
import { CalibartionCreateDilaogComponent } from './calibartion-create-dilaog/calibartion-create-dilaog.component';
import { CreateEnvironmentalConditionComponent } from './create-environmental-condition/create-environmental-condition.component';
import { UpdateCalibrationDialogComponent } from './update-calibration-dialog/update-calibration-dialog.component';
import { CreateCertificateDialogComponent } from './create-certificate-dialog/create-certificate-dialog.component';
import { CertificateReservationDialogComponent } from './certificate-reservation-dialog/certificate-reservation-dialog.component';
import { CreateKindDialogComponent } from './create-kind-dialog/create-kind-dialog.component';
import { CertificateReviseDialogComponent } from './certificate-revise-dialog/certificate-revise-dialog.component';
import { CreateBrandDialogComponent } from './create-brand-dialog/create-brand-dialog.component';
import { UpdateWorkDialogComponent } from './update-work-dialog/update-work-dialog.component';
import { DeliveryDeviceTransactionProductComponent } from './delivery-device-transaction-product/delivery-device-transaction-product.component';
import { AssignWorkPointsDialogComponent } from './assign-work-points-dialog/assign-work-points-dialog.component';
import { CustomerConfirmMailSendDialogComponent } from './customer-confirm-mail-send-dialog/customer-confirm-mail-send-dialog.component';
import { SurveyCustomerSendComponent } from './survey-customer-send/survey-customer-send.component';
import { ExpiryCertificateDeviceComponent } from './expiry-certificate-device/expiry-certificate-device.component';
import { EquipmentDialogComponent } from './equipment-dialog/equipment-dialog.component';
import { AssignmentMovementDialogComponent } from './assignment-movement-dialog/assignment-movement-dialog.component';
import { ExternalIntegrationDialogComponent } from './external-integration-dialog/external-integration-dialog.component';
import { DescriptionDialogComponent } from './description-dialog/description-dialog.component';
import { AnnualLeaveEntitlementDialogComponent } from './annual-leave-entitlement-dialog/annual-leave-entitlement-dialog.component';
import { SendCertificateMailComponent } from './send-certificate-mail/send-certificate-mail.component';
import { GetAllPersonsPointDialogComponent } from './get-all-persons-point-dialog/get-all-persons-point-dialog.component';
import { UpdateProductDialogComponent } from './update-product-dialog/update-product-dialog.component';
import { LeaveEntitlementDialogComponent } from './leave-entitlement-dialog/leave-entitlement-dialog.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { SendDeliveryMailDialogComponent } from './send-delivery-mail-dialog/send-delivery-mail-dialog.component';
import { VaultTransactionMovementsDialogComponent } from './vault-transaction-movements-dialog/vault-transaction-movements-dialog.component';
import { EquipmentHistoryDialogComponent } from './equipment-history-dialog/equipment-history-dialog.component';
import { CreateNotificateDialogComponent } from './create-notificate-dialog/create-notificate-dialog.component';
import { HasReaderNotificationDialogComponent } from './has-reader-notification-dialog/has-reader-notification-dialog.component';
import { NotificationDetailDialogComponent } from './notification-detail-dialog/notification-detail-dialog.component';
import { SelectedPersonPointComponent } from './selected-person-point/selected-person-point.component';
import { CreateReminderDialogComponent } from './create-reminder-dialog/create-reminder-dialog.component';
import { UpdateReminderDialogComponent } from './update-reminder-dialog/update-reminder-dialog.component';
import { ReminderSettingDialogComponent } from './reminder-setting-dialog/reminder-setting-dialog.component';
import { UpdateVaultVaultMovementDialogComponent } from './update-vault-vault-movement-dialog/update-vault-vault-movement-dialog.component';
import { ProductVariantDefinitionComponent } from './product-variant-definition/product-variant-definition.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TransactionTotalDisountRateDialogComponent } from './transaction-total-disount-rate-dialog/transaction-total-disount-rate-dialog.component';
import { NoteDialogComponent } from './note-dialog/note-dialog.component';
import { CreateCategoryDialogComponent } from './create-category-dialog/create-category-dialog.component';
import { DepertmantDialogComponent } from './depertmant-dialog/depertmant-dialog.component';
import { MissionDialogComponent } from './mission-dialog/mission-dialog.component';
import { PersonLeaveDetailComponent } from './person-leave-detail/person-leave-detail.component';
import { PersonPointDetailComponent } from './person-point-detail/person-point-detail.component';
import { CustomerConfirmCodeComponent } from './customer-confirm-code/customer-confirm-code.component';
import { CustomerConfirmDialogComponent } from './customer-confirm-dialog/customer-confirm-dialog.component';
import { MeasurementResultDialogComponent } from './measurement-result-dialog/measurement-result-dialog.component';
import { SignedCertificateDialogComponent } from './signed-certificate-dialog/signed-certificate-dialog.component';

@NgModule({
  declarations: [
    RoleManagmentUpdateComponent,
    ProductCreateSerialnoComponent,
    ProductMovementCreateComponent,
    SubProductCreateComponent,
    TransactionCreateDilaogComponent,
    ConfirmDialogComponent,
    TransactionUpdateDialogComponent,
    TransactionUpdateComponent,
    TransactionPrivateCodeConfirmedDialogComponent,
    CreateVaultDialogComponent,
    CreateVaultMovementComponent,
    FileUploadDialogComponent,
    CreatePersonComponent,
    SendpdfDialogComponent,
    CreateVaultCompanyMovementComponent,
    CreateActionComponent,
    SendPrintTransactionComponent,
    CreateCompanyComponent,
    CreateProductComponent,
    CreateWorkerDialogComponent,
    PersonLeaveComponent,
    PayrollComponent,
    PersonPointDialogComponent,
    CreateBrandModelComponent,
    CreateDeviceDialogComponent,
    DeviceDeliveryDialogComponent,
    UpdateDeviceDialogComponent,
    ReferenceTransactionsComponent,
    ProcedureDialogComponent,
    DeviceClassDialogComponent,
    CreateDeliveryDeviceComponent,
    DeliveryUpdateDialogComponent,
    DeliveryDeviceUpdateDialogComponent,
    DialogReferenceDeviceMovementComponent,
    CalibartionCreateDilaogComponent,
    CreateEnvironmentalConditionComponent,
    UpdateCalibrationDialogComponent,
    CreateCertificateDialogComponent,
    CertificateReservationDialogComponent,
    CreateKindDialogComponent,
    CertificateReviseDialogComponent,
    CreateBrandDialogComponent,
    UpdateWorkDialogComponent,
    DeliveryDeviceTransactionProductComponent,
    AssignWorkPointsDialogComponent,
    CustomerConfirmMailSendDialogComponent,
    SurveyCustomerSendComponent,
    ExpiryCertificateDeviceComponent,
    EquipmentDialogComponent,
    AssignmentMovementDialogComponent,
    ExternalIntegrationDialogComponent,
    DescriptionDialogComponent,
    AnnualLeaveEntitlementDialogComponent,
    SendCertificateMailComponent,
    GetAllPersonsPointDialogComponent,
    UpdateProductDialogComponent,
    LeaveEntitlementDialogComponent,
    SendDeliveryMailDialogComponent,
    VaultTransactionMovementsDialogComponent,
    EquipmentHistoryDialogComponent,
    CreateNotificateDialogComponent,
    HasReaderNotificationDialogComponent,
    NotificationDetailDialogComponent,
    SelectedPersonPointComponent,
    CreateReminderDialogComponent,
    UpdateReminderDialogComponent,
    ReminderSettingDialogComponent,
    UpdateVaultVaultMovementDialogComponent,
    ProductVariantDefinitionComponent,
    TransactionTotalDisountRateDialogComponent,
    NoteDialogComponent,
    CreateCategoryDialogComponent,
    DepertmantDialogComponent,
    MissionDialogComponent,
    PersonLeaveDetailComponent,
    PersonPointDetailComponent,
    CustomerConfirmCodeComponent,
    CustomerConfirmDialogComponent,
    MeasurementResultDialogComponent,
    SignedCertificateDialogComponent,
  ],
  imports: [
    CommonModule,
    CoreCommonModule,
    NgSelectModule,
    Ng2FlatpickrModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(),
    QuillModule.forRoot({
      modules: {
        toolbar: [
          [{ 'font': ['Arial', 'Times New Roman', 'Verdana', 'Georgia', 'Courier'] }],
          ['bold', 'italic', 'underline'],
          [{ 'list': 'ordered' }, { 'list': 'bullet' }],
          ['link'],
          [{ 'size': ['small', 'normal', 'large', 'huge'] }]
        ]
      }
    }),
    BlockUIModule.forRoot(),
    NgbTimepickerModule,
    NgbDatepickerModule,
    NgbModule,
    NgxDatatableModule,
    DragDropModule,
    NgbModalModule
  ]
})
export class DialogsModule { }
